export default __webpack_public_path__ + "static/media/page9Image2.8c8d1aac.jpg";